import ArrowCheck from "../../../public/images/ArrowCheck";
import QuestionIcon from "../../../public/images/QuestionIcon";
import PricesCards from "../../components/PricesCards/PricesCards";
import SliderCountries from "../../components/SliderCountries/SliderCountries";
import { PRICING_PLANS } from "../../mocks/pricingPlans";
import { SPECIFICATIONS } from "../../mocks/specifications";
import "./prices.scss";

export default function Prices() {
  return (
    <div className="prices">
      <div className="prices__header">
        <h2>Pricing plans for teams of all sizes</h2>
        <p>
          Nisi nulla minim deserunt adipisicing est consectetur sint labore
          commodo tempor tempor nisi. Deserunt tempor laboris aute labore.
        </p>
      </div>

      <PricesCards />
      <div className="prices__title">
        <h2>Feature Table</h2>
        <p>Choose the perfect plan for your business needs</p>
      </div>
      <div className="prices__moreInfo" id="moreInfo">
        <div className="prices__moreInfo__header">
          <div className="prices__moreInfo__header__empty" />

          <div className="prices__moreInfo__header__plans">
            {PRICING_PLANS.map((plan) => (
              <div
                key={plan.id}
                className="prices__moreInfo__header__plans__plan"
              >
                <h2>{plan.name}</h2>
                <h3>
                  ${plan.price}
                  <span>/user per month</span>
                </h3>
              </div>
            ))}
          </div>
        </div>
        {Object.entries(SPECIFICATIONS).map(([groupKey, group], idx, arr) => (
          <div key={groupKey} className="prices__moreInfo__groups">
            <div className="prices__moreInfo__groups__group">
              <h2>{group.title}:</h2>

              {Object.entries(group.items).map(([itemKey, label]) => (
                <div
                  key={itemKey}
                  className="prices__moreInfo__groups__group__row"
                >
                  <div className="prices__moreInfo__groups__group__row__label">
                    {label} <QuestionIcon />
                  </div>

                  <div className="prices__moreInfo__groups__group__row__cells">
                    {PRICING_PLANS.map((plan) => {
                      const hasFeature =
                        plan.features?.[groupKey]?.[itemKey] === true;

                      return (
                        <div
                          key={`${plan.id}-${groupKey}-${itemKey}`}
                          className="prices__moreInfo__groups__group__row__cells__cell"
                        >
                          {hasFeature ? (
                            <div className="prices__moreInfo__groups__group__row__cells__cell__arrow">
                              <ArrowCheck color="#fff" width={16} height={16} />
                            </div>
                          ) : (
                            <span>-</span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="prices__countries">
        <h2>Countries in which we provide numbers</h2>
        <SliderCountries />
      </div>
    </div>
  );
}
